// Copyright 2016 Sorama B.V.

import { IParameterizedValueConverter } from "aurelia-binding-ext";
import { NotSupportedError } from "errors/NotSupportedError";
import { Unit, UnitValue } from "units/Unit";
import { UnitParser } from "units/UnitParser";

export class UnitValueToStringValueConverter implements IParameterizedValueConverter<string, UnitValue, number> {
    public toView(value: UnitValue, decimals = 2): string {
        // Make chaining of this converter to a NullToX ValueConverter possible
        if (value === null || value === undefined || value.value === null || value.value === undefined) {
            return null;
        }
        if (typeof value.value !== "number") {
            throw new Error(value.unit.unit + " value must be a number. It is a " + typeof value.value + " instead.");
        }

        if (value.unit === null || value.unit === undefined) {
            throw new Error("UnitValue must have a unit defined.");
        }

        return value.value.toFixed(decimals) + " " + value.unit.unit;
    }

    public fromView(value: string, decimals: number): UnitValue {
        throw new NotSupportedError("Converting from string to UnitValue is not supported.");
    }
}
